<div class="outer-container" fxLayout="column" fxLayoutAlign="center center">
    <div class="container" fxLayout="column" fxLayoutAlign="center center">
        <h1>Oops!</h1>
        <p>We couldn't find that page.</p>
        <button mat-raised-button class="rollit-button " color="primary" routerLink="/">RETURN HOME</button>
    </div>
</div>